
import type { ApplicationContext } from '@mimir/common/context/applicationContext';

// This replaces backslashes to be able to pass the path to evalScript. Works equally on macOS and Windows
// to keep the path intact otherwise, to be able to match with the exact path set on the project clip.
export function escapeBackslashes(pathForScript: string | null | undefined) {
  let result = pathForScript;
  if (result) {
    result = result.replace(/\\/g, '\\\\');
  }

  return result;
}

// This escapes backslash and double quote characters, so that the script string we generate and send to CEP evalScript does not break.
export function getSanitizedScriptParam(param: string) {
  return param.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

export function getPathForScriptWith(applicationContext: ApplicationContext, pathForScript: string | null | undefined) {
  let result = pathForScript;
  if (result && applicationContext.isWindows) {
    result = result.replace(/\\/g, '\\\\');
    result = result.replace(/\//g, '\\\\');
  }

  return result;
}
